module.exports = "<footer class=\"main-footer\">\n  <strong>&copy; Big City Promotions</strong> - All Rights Reserved.\n  reserved.\n</footer>\n"